module.exports = __webpack_public_path__ + "static/media/7.6b14000b.mp3";